// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3bZkf","upload":"Small_upload__19SF2","imageWrap":"Small_imageWrap__2ABQa","removeBtn":"Small_removeBtn__3Erev"};